/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {KTIcon} from '../../../../_metronic/helpers'

const ParameterNameWidget = ({parameterData}) => {
  return (
    <a href='#' className={`card hoverable shadow mb-4`}>
      <div className='card-body d-flex align-items-center'>
        <div className='symbol symbol-70px me-3'>
          <img src={parameterData?.icon} alt='' />
        </div>

        <div>
          <div className={`fw-bold fs-2 mb-1`}>{parameterData?.name}</div>
          <div className={`fw-semibold text-muted fs-7 mb-2`}>
            {getTimeFormat(parameterData?.last_timestamp)}
          </div>

          <div className={`fw-semibold`}>
            {parameterData?.current_status === 'offline' ? (
              <span className='badge badge-secondary'>Offline</span>
            ) : parameterData?.current_status === 'normal' ? (
              <span className='badge badge-success'>Normal</span>
            ) : parameterData?.current_status === 'abnormal' ? (
              <span className='badge badge-danger'>Abnormal</span>
            ) : (
              <span className='badge badge-secondary'>{parameterData?.current_status}</span>
            )}
          </div>
        </div>
      </div>
    </a>
  )
}

export {ParameterNameWidget}

function getTimeFormat(timestamp) {
  const createdAt = new Date(timestamp * 1000)
  const formattedDate = createdAt.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  })
  const formattedTime = createdAt.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  })
  const formattedDateTime = `${formattedDate} ${formattedTime}`
  return formattedDateTime
}
